
import { Link } from "react-router-dom";
import { useState, useContext, useEffect } from "react";
import '../css/navbar.css';
import { useTranslation } from 'react-i18next';
import {ConfigContext} from "../helpers/ConfigContext";
import ReactModal  from 'react-modal';
import Btn from './Button';
import poems from '../res/snow_poems.png';
import weather_movies from '../res/weather_movies.png';
import songs from '../res/weather_songs.png';
import likedislikedforecast from '../res/icons8-love-60.png';
import myths from '../res/icons8-vomiting-unicorn-60.png';
import israelforecast from '../res/weather_israel.png';
import worldforecast from '../res/weather_hul.png';
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";
import {useCurrentUser} from "../helpers/UserContext";
import { GoogleLogin } from "@react-oauth/google";
import {useConfig} from "../helpers/useConfig";
import { useLocation } from 'react-router-dom';

const lngs = [
    { code: "0", native: "Eng" },
    { code: "1", native: "עב" }
];
function Sidebar({layout, cssClasses}) {
    function do_something(){
        window.scrollTo(0, 0);
        if (screenWidth < 1600)
        {
            setIsOpen(false); 
        }
    }
    const { t, i18n } = useTranslation();
    const {configData, setConfig} = useConfig();
    var langcode = configData.lang;
    const location = useLocation();
    const isHomePage = location.pathname === '/';
    const handleTrans = (code) => {
        i18n.changeLanguage(code);
        configData.lang = code;
        setConfig({...configData});
        saveConfigData();
        window.location.reload();
      };

     const handleTempUnit = (code) => {
        configData.tempUnit = code;
        setConfig({...configData});
        saveConfigData();
        //window.location.reload();
      };

    const [isOpen, setIsOpen] = useState(false);
    const [isPopupOpen, setPopupIsOpen] = useState(false);
    const [isConnectContainerOpen, setIsConnectContainerOpen] = useState(false);
    const [isForecastOpen, setIsForecastOpen] = useState(false);
    const [isUserOpen, setIsUserOpen] = useState(false);
    const [isLayoutOpen, setIsLayoutOpen] = useState(false);
    const [iswhatelseOpen, setIswhatelseOpen] = useState(false);
    const [isWhatHappendOpen, setIsWhatHappendOpen] = useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [currentTitle, setCurrentTitle] = useState(false);
    const { currentUser, logout, loginSuccess, fetchCurrentUser } = useCurrentUser();
    const customStyles = {
    content: {
      top: '55%',
      left: '50%',
      right: 'auto',
      direction: (configData.lang == 1) ? 'rtl' : '',
      width:'410px',
      padding: '5px',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
    },
  };
    function handleToggle(){
        setIsOpen(!isOpen);
    }
    function LetterRail({ text }) {
        return (
            <span className="letter-rail">
                {Array.from(text).map((ch, i) => (
                    <span className="letter-rail-char" key={i}>
                        {ch === ' ' ? '\u00A0' : ch}
                    </span>
                ))}
            </span>
        );
    }
    const closeAndSyncConnection = () => {
        fetchCurrentUser(langcode);
        setIsConnectContainerOpen(false);
    }
    const toggleForecastOpen = () =>{
        setIsForecastOpen(!isForecastOpen);
    }
    const toggleLayoutOpen = () =>{
        setIsLayoutOpen(!isLayoutOpen);
    }
    const toggleUserOpen = () =>{
        setIsUserOpen(!isUserOpen);
    }
    const toggleIswhatelseOpen = () =>{
        setIswhatelseOpen(!iswhatelseOpen);
    }
    const toggleIsWhatHappendOpen = () =>{
        setIsWhatHappendOpen(!isWhatHappendOpen);
    }
    const OnLoginClick = () =>{
        setIsOpen(false); 
        setIsConnectContainerOpen(true);
    }
    const handleContent = () =>{
        if (screenWidth > 1600)
        {
            setIsOpen(true);
        }
        else
        {
          setIsOpen(false);  
        }
    }
     
    useEffect(() => {
            const handleResize = () => {
              setScreenWidth(window.innerWidth);
              handleContent();
              //alert(window.innerWidth);
    
            };
            handleResize();
            window.addEventListener('resize', handleResize);
            
       
            // Clean up the event listener when the component unmounts
            return () => {
              window.removeEventListener('resize', handleResize);
            };
            
          }, []); // Empty dependency array means this effect runs once on mount
    const month = new Date().getMonth() + 1;
    const year = new Date().getFullYear();

     const saveConfigData = () => {
        configData.layout = layout;
        localStorage.setItem('configData', JSON.stringify(configData));
        console.log ('saved' + JSON.stringify(configData));
        setCurrentTitle('saved' + JSON.stringify(configData));
        setPopupIsOpen(true);
    }

    return (
        <>
        <div id="sidebar" className={(langcode == 1)? 'rtl ' + cssClasses : cssClasses}>
                        
            <nav className={`${isOpen ? 'open': ''}`}>
            <div className={`menu ${isOpen ? 'open': ''}`} onClick={handleToggle}>
               <div className="hamburger"></div>
            </div>
            <ul className={`links ${isOpen ? 'open': ''}`}>
                {!isHomePage &&<li>
                    <a href={`/`}><i className="ti ti-home" />{t('HOME_PAGE')}</a>
                </li>}
                <li>
                    <Link className="toggle" onClick={() => toggleUserOpen()} data-google-vignette="false"><LetterRail text={`${t("LOGIN")}/${t("REGISTER")}`} />  {isUserOpen ? <ChevronUp /> : <ChevronDown />}</Link>
                    {isUserOpen &&
                         <ul id="user" className="">
                             <li>
                                
                            </li>
                            <li>
                                 {(!currentUser) && <div className="register-container"><Btn btnOnClick={() => OnLoginClick()} btnTitleText={t("LOGIN")}></Btn> 
                                                        <GoogleLogin onSuccess={loginSuccess}/>
                                                    </div>}
                                 {(currentUser) && <div className="register-container">{`${currentUser.display}`} <Btn btnOnClick={() => logout()} btnTitleText={t("SIGN_OUT")}></Btn> </div>}
                            </li>
                         </ul>
                    }
                </li>
               
                <li>
                    <Link className="toggle" onClick={() => toggleLayoutOpen()} data-google-vignette="false"><LetterRail text={t("LAYOUT")} /> {isLayoutOpen ? <ChevronUp /> : <ChevronDown />}</Link>
                    {isLayoutOpen &&
                    <ul id="Layout" className="">
                         
                        <li>
                            <Link onClick={() => do_something()} to={`/current`} data-google-vignette="false">{t('CURRENT_FIRST')} </Link>
                        </li>
                        <li>
                            <Link onClick={() => do_something()} to={`/forecast24`}  data-google-vignette="false">{t('24H_FIRST')}</Link>
                        </li>
                        <li>
                            <Link onClick={() => do_something()} to={`/NextDays`}  data-google-vignette="false">{t('NEXTDAYS_FIRST')}</Link>
                        </li>
                        <li>
                            <Link onClick={() => do_something()} to={`/Now`}  data-google-vignette="false">{t('NOW_DETAILED')}</Link>
                        </li>
                        <li>
                            <Btn
                                btnOnClick={() => saveConfigData()}
                                btnTitleText={t('SAVE_AS_LAUNCH')}
                                img="ArrowLeft"
                            ></Btn>
                        </li>
                    </ul>
                    }
                </li>
                <li>
                    <Link className="toggle" onClick={() => toggleForecastOpen()} data-google-vignette="false"><LetterRail text={t("FORECAST_TITLE")} /> {isForecastOpen ? <ChevronUp /> : <ChevronDown />}</Link>
                    {isForecastOpen &&
                    <ul id="forecast" className="">
                        <li>
                            <Link to={`/ForecastAbroad`} onClick={() => do_something()} className="more_icons_text" data-google-vignette="false"><div className="worldforecast more_icons" ></div>{t("WORLD")}</Link>
                        </li>
                        <li>
                            <Link to={`/ForecastIsrael`} onClick={() => do_something()} className="more_icons_text" data-google-vignette="false"><div className="israelforecast more_icons" ></div>{t("ISRAEL")}</Link>
                        </li>
                        <li>
                            <Link to={`/ForecastJob`} onClick={() => do_something()} data-google-vignette="false"><i className="ti ti-cloud" />{t("FORECASTER_JOB")}</Link>
                        </li>
                         <li>
                            <Link to={`/LoveHateForecasts`} onClick={() => do_something()} ><img src={likedislikedforecast} width="30" />{t("LIKED_FORECAST")}</Link>
                        </li>
                    </ul>
                    }
                </li>
                <li>
                    <Link className="toggle" onClick={() => toggleIswhatelseOpen()} img="ArrowLeft" data-google-vignette="false"><LetterRail text={t("WHAT_ELSE")} /> {iswhatelseOpen ? <ChevronUp /> : <ChevronDown />} </Link>
                    {iswhatelseOpen &&
                    <ul id="whatelse" className="">
                    <li>
                    <Link to={`/Radar`} onClick={() => do_something()} data-google-vignette="false"><i className="ti ti-radar" />{t("RAIN_RADAR")}</Link>
                    </li>
                    <li>
                        <Link to={`/Satellite`} onClick={() => do_something()} data-google-vignette="false"><i className="ti ti-cloud" />{t("SATELLITE")}</Link>
                    </li>
                    <li>
                        <Link to={`/GlobalWarming`} onClick={() => do_something()} ><i className="ti ti-cloud" />{t("GLOBAL_WARMING")}</Link>
                    </li>
                    <li>
                    <Link to={`/Runningtreks`} onClick={() => do_something()} ><i className="ti ti-cloud" />{t("RUNNING_TREKS")}</Link>
                    </li>
                    <li>
                        <Link to={`/Rain`} onClick={() => do_something()} data-google-vignette="false"><i className="ti ti-cloud-rain" />{t("RAIN")}</Link>
                    </li>
                    <li>
                        <Link to={`/Songs`} onClick={() => do_something()} className="more_icons_text"><div className="weather_songs more_icons" ></div>{t("SONGS")}</Link>
                    </li>
                    <li>
                        <Link to={`/Myths`} onClick={() => do_something()} ><img src={myths} width="30" />{t("MYTHS")}</Link>
                    </li>
                    <li>
                            <Link to={`/BestSeason`} onClick={() => do_something()} ><i className="ti ti-cloud" />{t("FSEASON_T")}</Link>
                    </li>
                    <li>
                         <a href={"https://v2013.02ws.co.il/online/?lang=" + (langcode)} target="_blank"><i className="ti ti-cloud" />{t("ONLINE")}</a>
                    </li>
                    <li>
                         <Link to={`/Radiosonde`} onClick={() => do_something()} ><i className="ti ti-cloud" />{t("RADIOSONDE")}</Link>
                    </li>
                    </ul>
                    }
                </li>
                <li>
                    <Link className="toggle" onClick={() => toggleIsWhatHappendOpen()} data-google-vignette="false"><LetterRail text={t("WHAT_HAPPEND")} /> {isWhatHappendOpen ? <ChevronUp /> : <ChevronDown />} </Link>
                    {isWhatHappendOpen &&
                    <ul id="whathappend" className="">
                        <li>
                            <Link to={`/Average`}  ><i className="ti ti-cloud" />{t("AVERAGE")}</Link>
                        </li>
                        <li>
                            <Link to={`/ThisMonth`} onClick={() => do_something()} ><i className="ti ti-cloud" />{t("MONTH")} {month}/{year} </Link>
                        </li>
                        <li>
                            <Link to={`/ChooseMonthYear`} onClick={() => do_something()} ><i className="ti ti-cloud" />{t("CHOOSE")}</Link>
                        </li>
                        <li>
                            <Link to={`/Records`} onClick={() => do_something()} ><i className="ti ti-cloud" />{t("RECORDS")}</Link>
                        </li>
                        <li>
                            <Link to={`/RainSeasons`} onClick={() => do_something()} ><i className="ti ti-cloud-rain" />{t("RAIN_SEASONS")}</Link>
                        </li>
                       
                        <li>
                            <Link to={`/Reports`} onClick={() => do_something()} ><i className="ti ti-flask" />{t("REPORTS")}</Link>
                        </li>
                        <li>
                            <Link to={`/Archive`} onClick={() => do_something()} ><i className="ti ti-archive" />{t("ARCHIVE")}</Link>
                        </li>
                        <li>
                            <Link to={`/Weatherclips`} onClick={() => do_something()} className="more_icons_text"><div className="weather_movies more_icons" ></div>{t("WEATHER_CLIPS")}</Link>
                        </li>
                        <li>
                            <Link to={`/Snow`} onClick={() => do_something()} ><i className="ti ti-cloud-snow" />{t("SNOW")}</Link>
                        </li>
                        <li>
                            <Link to={`/Poems`} onClick={() => do_something()} className="more_icons_text"><div className="snow_poems more_icons" ></div>{t("SNOW_POEMS")}</Link>
                        </li>
                        <li>
                            <Link to={`/Climate`} onClick={() => do_something()} ><i className="ti ti-cloud" />{t("CLIMATE")}</Link>
                        </li>
                        
                    </ul>
                    }   
                </li>
                 <li className="navigation">
                    <a onClick={() => do_something()} href={`/#graph_container`} data-google-vignette="false"><i className="ti ti-clock" /><LetterRail text={t('HOURLY')} /></a>
                </li>
                <li className="navigation">
                    <a onClick={() => do_something()} href={`/#forcast_days`} data-google-vignette="false"><i className="ti ti-sun-high" /><LetterRail text={t('FORECAST_4D')} /></a>
                </li>
                <li className="navigation">
                    <a onClick={() => do_something()} href={`/#notification_title`} data-google-vignette="false"><i className="ti ti-bell" /><LetterRail text={t('MESSAGES')} /></a>
                </li>
                <li>
                    <Link to={`/Forum#top`} onClick={() => do_something()} ><i className="ti ti-layout-columns" /><LetterRail text={t("CHAT_TITLE")} /></Link>
                </li>
               <li>
                    <Link to={`/Faq`} onClick={() => do_something()} ><i className="ti ti-question-mark" /><LetterRail text={t("FAQ")} /></Link>
                </li>
                <li>
                    <Link to={`/Tips`} onClick={() => do_something()} ><i className="ti ti-bolt" /><LetterRail text={t("TIPS")} /></Link>
                </li>
                <li>
                    <a href="https://pub.02ws.co.il" target="_blank"><i className="ti ti-leaf" /><LetterRail text={t("ADVERTISING")} /></a>
                </li>
                <li>
                    <Link onClick={() => do_something()} to={`/About`}  ><i className="ti ti-mail" /><LetterRail text={t("CONTACT_INFO")} /></Link>
                </li>
                <li>
                    <Link to={`/Contact`} onClick={() => do_something()} ><i className="ti ti-bell" /><LetterRail text={t("CONTACT_ME")} /></Link>
                </li>
               
                <li>
                     <div id="trans_btns">
                        {lngs.map((lng, i) => {
                        const { code, native } = lng;
                        return <Btn key={i} btnOnClick={() => handleTrans(code)} btnTitleText={native} cssClasses="btn-outline-secondary btn-sm"></Btn>;
                    })}
                    </div>
                </li>
                    {(langcode == 0)?
                    <li>
                        <div id="tempunit_btns">
                            <Btn key={'C'} btnOnClick={() => handleTempUnit('C')} btnTitleText={'C'} cssClasses="btn-outline-secondary btn-sm"></Btn>
                            <Btn key={'F'} btnOnClick={() => handleTempUnit('F')} btnTitleText={'F'} cssClasses="btn-outline-secondary btn-sm"></Btn>
                        </div>
                    </li>
                    : ''
                    }
            </ul>
            
            
            </nav>
        </div>
        <ReactModal
        isOpen={isConnectContainerOpen}
        contentLabel="Example Modal"
        style={customStyles}
        onRequestClose={() => setIsConnectContainerOpen(false)}
      >
        <Btn
          btnOnClick={() => setIsConnectContainerOpen(false)}
          btnTitleText={""}
          img={"X"}
          cssClasses="float-start"
        ></Btn>
        <iframe src={`https://v2013.02ws.co.il/login_form.php?lang=${langcode}`}  sandbox='allow-scripts allow-modal allow-forms allow-same-origin' scrolling="no" loading='eager' title="iframePopup" ></iframe>
        
        <Btn btnOnClick={() => closeAndSyncConnection()} btnTitleText={"Ok and deploy"}></Btn>
      </ReactModal>  
        <ReactModal
        isPopupOpen={isOpen}
        contentLabel="Example Modal"
        onRequestClose={() => setPopupIsOpen(false)}
      >
        <Btn
          btnOnClick={() => setPopupIsOpen(false)}
          btnTitleText={""}
          img={"X"}
          cssClasses="float-start"
        ></Btn>
        {currentTitle}

        <br />
        <br />
        <br />
        <Btn btnOnClick={() => setPopupIsOpen(false)} btnTitleText={"Ok"}></Btn>
      </ReactModal>
      </>
    )
}
export default Sidebar;
